import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const expiry = localStorage.getItem('loginExpiry');
    const isExpired = expiry && new Date().getTime() > parseInt(expiry);
    return localStorage.getItem('isLoggedIn') === 'true' && !isExpired;
  });

  // ⏱ Auto logout timer (setTimeout) ref
  useEffect(() => {
    if (isAuthenticated) {
      const expiry = localStorage.getItem('loginExpiry');
      const timeLeft = expiry - new Date().getTime();

      if (timeLeft > 0) {
        const timeout = setTimeout(() => {
          logout();
        }, timeLeft);
        return () => clearTimeout(timeout);
      } else {
        logout();
      }
    }
  }, [isAuthenticated]);

  const login = () => {
    const expiry = new Date().getTime() + 2 * 60 * 60 * 1000; // 2 hours
    localStorage.setItem('isLoggedIn', 'true');
    localStorage.setItem('loginExpiry', expiry.toString());
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('loginExpiry');
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
